import './styles.scss';

import React, { useEffect, useState } from 'react';
import { Flex, Loader } from '@gjensidige/builders-components';

import tracker from './tracking';
import { InputWidgetContainer } from './containers/InputWidgetContainer';
import { WidgetProps } from './interfaces/Types';
import { AppHelper } from './utils/AppHelper';

interface AppProps {
  additionalDataUrl?: string | null;
}

export const App: React.FC<AppProps> = ({ additionalDataUrl }: AppProps) => {
  const defaultData: WidgetProps = AppHelper.getDefaultData();
  const [isReady, setIsReady] = useState(false);
  const [enonicData, setEnonicData] = useState(defaultData);

  useEffect(() => {
    const getInitialdata = async () => {
      let processedData;
      if (additionalDataUrl) {
        const additionalData = await AppHelper.getEnonicContent(
          additionalDataUrl
        );
        processedData = AppHelper.prepareData(enonicData, additionalData);
      } else {
        // Even without external data, run prepareData to apply default data for test environment
        processedData = AppHelper.prepareData(enonicData, {});
      }
      setEnonicData(processedData);
      setIsReady(true);
    };
    getInitialdata();
    trackPartsView();
  }, []);

  const trackPartsView = () => {
    tracker.trackEvent({
      eventLabel: 'webshop_home_widget',
      eventAction: 'impression',
      eventCategory: 'impression',
      eventModule: 'webshop'
    });
  };

  return (
    <div className="app-container">
      <Flex justify="center">
        {isReady ? (
          <InputWidgetContainer enonicData={enonicData} />
        ) : (
          <Loader size="lg" variant="spinner" />
        )}
      </Flex>
    </div>
  );
};
